import { ENoteActionsTypes } from '../../actions/favoriteEntities/notes';
import {
  FAVORITE_ENTITIES_ERROR_REMOVE_FAVORITE,
  FAVORITE_ENTITIES_FETCH_REMOVE_FAVORITE,
  FAVORITE_ENTITIES_GET_FAVORITE_ENTITIES_TYPE,
  FAVORITE_ENTITIES_REMOVE_ALL_FAIL,
  FAVORITE_ENTITIES_REMOVE_ALL_FETCH,
  FAVORITE_ENTITIES_REMOVE_ALL_SUCCESS,
  FAVORITE_ENTITIES_SUCCESS_REMOVE_FAVORITE,
} from '../../constants/actionTypes';
import { TReduxActions } from '../../types/redux';
import { EGetFavoriteEntitiesStatus, INoteFetchingInfo, IResultsState } from '../../types/results';

const defaultFavoriteEntities: IResultsState = {
  total: 0,
  status: EGetFavoriteEntitiesStatus.Initial,
  filters: {
    dealType: null,
    favoriteEntityType: null,
    orderField: null,
    showFiltersModal: false,
  },
  favoriteEntities: [],
  hasMore: false,
  restoringFavoriteEntities: [],
  removeFavorite: {
    entityIds: null,
  },
  editingNotes: {},
  deletingNotes: [],
};

const NOTES_FETCHING_STATE = {
  isFetching: true,
  isFetchSuccess: false,
  isFetchFail: false,
};

const NOTES_FETCH_SUCCESS_STATE = {
  isFetching: false,
  isFetchSuccess: true,
  isFetchFail: false,
};

const NOTES_FETCH_FAIL_STATE = {
  isFetching: false,
  isFetchSuccess: false,
  isFetchFail: true,
};

export function resultsReducer(state: IResultsState = defaultFavoriteEntities, action: TReduxActions) {
  switch (action.type) {
    //TODO: зарефакторить эту жуть
    case FAVORITE_ENTITIES_GET_FAVORITE_ENTITIES_TYPE:
      return {
        ...state,
        status: action.status,
        filters: action.status === EGetFavoriteEntitiesStatus.Succeed ? action.filters : state.filters,
        hasMore: action.status === EGetFavoriteEntitiesStatus.Succeed ? action.hasMore : state.hasMore,
        favoriteEntities:
          action.status === EGetFavoriteEntitiesStatus.Succeed
            ? state.status === EGetFavoriteEntitiesStatus.NextPageLoading
              ? state.favoriteEntities.concat(action.favoriteEntities)
              : action.favoriteEntities
            : state.favoriteEntities,
        total: action.status === EGetFavoriteEntitiesStatus.Succeed ? action.total : state.total,
      };

    case FAVORITE_ENTITIES_FETCH_REMOVE_FAVORITE:
      return {
        ...state,
        removeFavorite: {
          ...state.removeFavorite,
          entityIds: state.removeFavorite.entityIds
            ? state.removeFavorite.entityIds.concat(action.entityId)
            : [action.entityId],
        },
      };

    case FAVORITE_ENTITIES_SUCCESS_REMOVE_FAVORITE:
      return {
        ...state,
        removeFavorite: {
          ...state.removeFavorite,
          entityIds: state.removeFavorite.entityIds
            ? state.removeFavorite.entityIds.filter(id => id !== action.entityId)
            : null,
        },
        favoriteEntities: state.favoriteEntities.filter(favoriteEntity => favoriteEntity.entityId !== action.entityId),
        editingNotes: deleteEditingNote(state, action.entityId),
      };

    case FAVORITE_ENTITIES_ERROR_REMOVE_FAVORITE:
      return {
        ...state,
        removeFavorite: {
          ...state.removeFavorite,
          entityIds: null,
        },
      };

    case FAVORITE_ENTITIES_REMOVE_ALL_FETCH:
      return { ...state, status: EGetFavoriteEntitiesStatus.Loading };
    case FAVORITE_ENTITIES_REMOVE_ALL_FAIL:
      return { ...state, status: EGetFavoriteEntitiesStatus.Failed };
    case FAVORITE_ENTITIES_REMOVE_ALL_SUCCESS:
      return {
        ...state,
        status: EGetFavoriteEntitiesStatus.Succeed,
        favoriteEntities: [],
      };

    case ENoteActionsTypes.StartEditNote:
      return {
        ...state,
        editingNotes: Object.assign({}, state.editingNotes, { ...action.payload }),
      };

    case ENoteActionsTypes.CancelEditNote:
      return {
        ...state,
        editingNotes: deleteEditingNote(state, action.payload.entityId),
      };

    case ENoteActionsTypes.SetFetchNote:
      return {
        ...state,
        editingNotes: updateFetch(state, action.payload.entityId, NOTES_FETCHING_STATE),
      };

    case ENoteActionsTypes.SetFetchSuccessNote:
      return {
        ...state,
        editingNotes: updateFetch(state, action.payload.entityId, NOTES_FETCH_SUCCESS_STATE),
      };

    case ENoteActionsTypes.SetFetchFailNote:
      return {
        ...state,
        editingNotes: updateFetch(state, action.payload.entityId, NOTES_FETCH_FAIL_STATE),
      };

    case ENoteActionsTypes.UpdateEntityNote:
      return {
        ...state,
        favoriteEntities: state.favoriteEntities.map(entity => {
          return entity.entityId === action.payload.entityId ? { ...entity, note: action.payload.comment } : entity;
        }),
      };

    case ENoteActionsTypes.SetPropForDeletingNote:
      return {
        ...state,
        deletingNotes: state.deletingNotes.concat(action.payload.entityId),
      };

    case ENoteActionsTypes.RemovePropForDeletingNote:
      return {
        ...state,
        deletingNotes: state.deletingNotes.filter(id => id !== action.payload.entityId),
      };

    default:
      return state;
  }
}

function deleteEditingNote({ editingNotes }: IResultsState, entityId: number) {
  return Object.keys(editingNotes).reduce((prev, curr) => {
    const numberId = Number(curr);

    return numberId === entityId ? prev : Object.assign({}, prev, { [curr]: editingNotes[numberId] });
  }, {});
}

function updateFetch({ editingNotes }: IResultsState, entityId: number, fetchState: INoteFetchingInfo) {
  return Object.keys(editingNotes).reduce((prev, curr) => {
    const numberId = Number(curr);

    return numberId === entityId
      ? Object.assign({}, prev, { [numberId]: { ...fetchState } })
      : Object.assign({}, prev, { [curr]: editingNotes[numberId] });
  }, {});
}
